// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib/index.mjs';
export function IoMdAdd (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"},"child":[]}]})(props);
};
